import Vue from 'vue';
import globalConfigs from './GlobalConfigs/GlobalConfigs';

const getLenguage = () => {
  switch (globalConfigs.currency) {
    case 'DOP': //Republica Dominicana
      return 'es-DO'
    case 'USD':
      return 'en-US'
    default:
      return globalConfigs.language || 'ES'
  } 
}

export const reformat = (value: number,
                         lang: string = getLenguage(),
                         style: string = 'currency',
                         currency: string = globalConfigs.currency || 'EUR',
                         currencyDisplay: string = 'symbol',
                         minimumFractionDigits: number = 2,
                         maximumFractionDigits: number = 2) => {
  let formattedString = Number(value).toLocaleString(lang, {
    style,
    currency,
    currencyDisplay,
    minimumFractionDigits,
    maximumFractionDigits,
  });
  return formattedString.replace(/US\$|RD\$/g, '$');
};

Vue.filter('reFormat', (
  value: number,
  lang?: string,
  minimumFractionDigits?,
  maximumFractionDigits?,
  style?: string,
  currencyDisplay?: string,
  currency?: string,
) => {
  return reformat(value, lang, style, currency, currencyDisplay, minimumFractionDigits, maximumFractionDigits);
});
export const maxLen = (value: any[], length) => {
  if (value.length <= length) {
    return value;
  }
  return `${value.slice(0, length)}...`;
};
Vue.filter('maxLen', (
  value: any[],
  length: number = 20,
) => {
  return maxLen(value, length);
});

export function formatTime(date: string) {
  const [hour, minSec] = date.split(':');
  const number1 = +hour - 12;
  if (+hour === 0) {
    return 12 + ':' + minSec + 'am';
  }
  if (number1 < 0) {
    return hour + ':' + minSec + 'am';
  }

  return !!+number1 ? number1 + ':' + minSec + 'pm' : 12 + ':' + minSec + 'pm';
}

export function formatDateTime(dateOrDateTime: string) {
  const [date, time] = dateOrDateTime.split('T');
  const [year, month, day] = date.split('-');
  const formattedDate = `${day}/${month}/${year}`;
  const formattedTime = formatTime(time);
  return `${formattedDate} ${formattedTime}`;
}

Vue.filter('formatTime', (dateOrDateTime = '0:00', datetime?: boolean) => {
    if (!datetime) {
      return formatTime(dateOrDateTime);
    }
    return formatDateTime(dateOrDateTime);


    // 2023-01-16T04:01:52
  },
);

Vue.filter('formatTimehhmm', (minutes = 0) => {
    let hours = minutes / 60;
    let mins = Math.floor(minutes % 60);

    return `${ Math.floor(hours) }h ${ minutes > 9 ? mins : '0' + mins }min`;

  },
);

Vue.filter('decimalFormat', (
  value: string | number,
  lang: string = globalConfigs.language || 'ES', 
  minimumFractionDigits: number = 2,
  maximumFractionDigits: number = 2) => {
  return Number(value).toLocaleString(lang, 
    {minimumFractionDigits: minimumFractionDigits,
     maximumFractionDigits: maximumFractionDigits});
});

function isDecimal(input) {
  // Convertir el input a número
  const numero = parseFloat(input);    
  // Verificar si es un número y si tiene parte decimal
  return !isNaN(numero) && !Number.isInteger(numero);
}

Vue.filter('decimalAndIntegerFormat', (
  value: string | number,
  lang: string = globalConfigs.language || 'ES', 
  minimumFractionDigits: number = 2,
  maximumFractionDigits: number = 2) => {
  
  if(isDecimal(value)) {
    return Number(value).toLocaleString(lang, 
      {minimumFractionDigits: minimumFractionDigits,
       maximumFractionDigits: maximumFractionDigits});
  }else {
    return +value;
  }
  
});
